const styles = (theme) => ({
  rowNew: {
    ...theme.mixins.row.new,
  },
});

export default styles;
